const devConfig = {
  api: {
    portalLocal: 'http://10.0.0.93:8080',
    customer: 'https://th-test-customer-api.dimorder.com',
    dimorder: 'https://th-test-api.dimorder.com',
    node: 'https://th-test-node.dimorder.com',
  },
  env: 'test',
  keetaAppId: '3917793481',
  receipt: 'http://th-test-mp-order.dimorder.com/',
  report: 'https://th-test-report-api.dimorder.com/report/',
}

export default devConfig
